import React, { Component } from 'react';
import {
    MDBContainer,
    MDBModal,
    MDBModalBody,
    MDBModalHeader,
    MDBModalFooter
} from 'mdbreact';
import { Button } from 'reactstrap'
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';

class InviteUser extends Component {
    state = {
        modal: true
    }

    changeValue = (e) => {
        e.preventDefault();
        const value = e.target.value
        const name = e.target.name
        //confirm password
        this.setState({
            [name]: value
        })
    }

    render() {
        return (
            <MDBContainer>
                <MDBModal isOpen={this.state.modal} toggle={() => this.props.deleteMarker()}>
                    <MDBModalHeader toggle={() => this.props.deleteMarker()}>Invite User</MDBModalHeader>
                    <MDBModalBody>
                        <form>
                            <div>
                                <TextField
                                    label='First Name'
                                    name='first'
                                    variant="outlined"
                                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                    required={true}
                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                />
                            </div>
                            <div>
                                <TextField
                                    label='Last Name'
                                    name='last'
                                    variant="outlined"
                                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                    required={true}
                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                />
                            </div>
                            <div>
                                <TextField
                                    label='Email'
                                    name='Email'
                                    variant="outlined"
                                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                    required={true}
                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                />
                            </div>
                            <div>
                                <TextField
                                    id='Role'
                                    select
                                    label='Role'
                                    variant='outlined'
                                    required={true}
                                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                    className="without-padding"
                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                    InputProps={{ style: { minWidth: '245px', marginBottom: '10px' } }}
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left"
                                            },
                                            getContentAnchorEl: null
                                        }
                                    }}
                                    onChange={(e) => this.changeValue(e)}
                                >
                                    <MenuItem value={""} hidden></MenuItem>
                                    <MenuItem value={1}>{'Admin'}</MenuItem>
                                    <MenuItem value={2}>{"User"}</MenuItem>
                                </TextField>
                            </div>
                            <div>
                                <TextField
                                    id='UserLevel'
                                    select
                                    label='UserLevel'
                                    variant='outlined'
                                    required={true}
                                    // error={this.state.isErrors && this.state.errorList && this.state.errorList[x.name]}
                                    // helperText={this.state.isErrors && this.state.errorList && this.state.errorList[x.name] ? `${x.displayName} is required` : null}
                                    className="without-padding"
                                    InputLabelProps={{ style: { color: '#4285f4' } }}
                                    InputProps={{ style: { minWidth: '245px', marginBottom: '10px' } }}
                                    SelectProps={{
                                        MenuProps: {
                                            anchorOrigin: {
                                                vertical: "bottom",
                                                horizontal: "left"
                                            },
                                            getContentAnchorEl: null
                                        }
                                    }}
                                    onChange={(e) => this.changeValue(e)}
                                >
                                    <MenuItem value={""} hidden></MenuItem>
                                    <MenuItem value={1}>{'Maintainer'}</MenuItem>
                                    <MenuItem value={2}>{"Reader"}</MenuItem>
                                </TextField>
                            </div>
                            <Button onClick={() => this.props.submitForm(this.state)}>Submit</Button>
                        </form>

                    </MDBModalBody>
                    <MDBModalFooter>
                        <Button color="primary" size='sm' onClick={() => this.props.confirm()}>Yes</Button>
                        <Button color="primary" outline size='sm' onClick={() => this.props.deleteMarker()} >No</Button>
                    </MDBModalFooter>
                </MDBModal>
            </MDBContainer>
        );
    }
}

export default InviteUser;


// WEBPACK FOOTER //
// ./src/components/modals/InviteUser.js